
<script>
 import { createEventDispatcher } from 'svelte';
 import {isDebug} from '../stores';

  const dispatch = createEventDispatcher();
  
  export let messages = [];
  export let staffMembers = [];
  export let rooms = [];
  
  function getName(m) {

    let s = staffMembers.filter( o => {
      return o.guid == m.message.staff;
    });
    console.log(s)

    return s.length ? s[0].name : "unkown staff member";
  }
  function getRoom(m) {
    console.log(rooms)
    let r = rooms.filter(o => {
      return o.guid == m.message.room;
    });
    return r.length ? r[0].name : "unkwon room"
  }

  function confirm(m) {
    dispatch('confirm', {
      message: JSON.stringify(m.message)
    });
  }

  function resolveSOS(m) {
    dispatch('resolveSOS', {
      message: JSON.stringify(m.message)
    });
  }

  function confirmed(m) {
    return m.message.confirmed;
  }

</script>

<section class="info-area">
  <div id="protocol" class="protocol">
 
    <ul>
      {#each messages as message }
        {#if message.message.sos}
          <li class="message sos">
            <div class="details">
              <span class="message-main">SOS</span>
              <span class="message-from"><span class="timestamp">{message.message.timestamp}</span></span>
              <button type="button" class="check" on:click={resolveSOS(message)}><span class="fa-solid fa-thumbs-up"></span>
            </div>
          </li>
        {:else}
	  <li class="message" class:confirmed={confirmed(message)} class:unconfirmed={!confirmed(message)}>
            <div class="details">
	      <div class="message-main">
            	<span class="member">{getName(message)}</span><span class="to fa-solid fa-arrow-right"></span><span class="room">{getRoom(message)}</span>
	      </div>
	      <div class="message-from">
		<span class="timestamp">{message.message.timestamp}</span><span class="from">User</span>
	      </div>
	      {#if message.message.confirmed == 0}
		<button type="button" class="check" on:click={confirm(message)}><span class="fa-solid fa-thumbs-up"></span></button>
	      {:else}<span class="checked"><span class="fas fa-check"></span></span>
		{/if}
              </div>
          </li>
        {/if}
      {/each}
    </ul>
  </div>

</section>
